/**
 * index.js 自定义vue自动指令
 * 如需页面元素实现某个指令，只需在对应的元素上添加"v-xxx"属性即可，如"v-ioc-tooltip"指令可悬浮弹出自定义tooltip
 */
import Vue from 'vue'
import utils from '@src/common/utils'
import permissionCode from '@src/common/config/permissionCode'
/**
 * [按钮权限]
 * @param  {[type]} el      [DOM]
 * @param  {[type]} btnName [按钮名称] USER:ADD
 * @return {[type]}         [description]
 */
var getBtnsPermission = function (el, btnName) {
  // if (el) {
  //   return true;
  // }
  const permission = utils.Cache.get('BTN_PERMISSION') || []

  const btnPath = btnName.split(':')[0]
  // 根据path获取,缓存中的value(按钮权限)值
  let cacheObj = ''
  for (let i = 0; i < permission.length; i++) {
    if (permission[i].path == btnPath && permission[i].authorityValue) {
      // utils.Log.debug('directive===>permission[i]:', permission[i], ', jsValue:', ', btnPath:', btnPath);
      cacheObj = permission[i]
    }
  }
  if (!cacheObj) return false

  const cacheValue = cacheObj.authorityValue || ''

  // 根据key值 获取映射表中的 value值
  const jsKey = btnName
  const array = permissionCode

  let jsValue
  /* array.forEach((arrayItem) => {
    if (arrayItem[jsKey]) return (jsValue = arrayItem[jsKey])
  }) */
  // 替换上面减少循环
  array.some((arrayItem) => {
    if (arrayItem[jsKey]) return (jsValue = arrayItem[jsKey])
  })
  //   utils.Log.debug('directive===>cacheValue:', cacheValue, ', jsValue:', jsValue, ', btnPath:', btnPath);

  // 判断缓存中的value值是否含有,映射表中的value值，含有，则表示按钮具有此权限值，否则，则表示按钮不具有此权限值
  if (cacheValue.indexOf(jsValue) != -1 || jsValue == 'I_000000') {
    return true
  } else {
    return false
  }
}

// 可根据用户配置的data-title的文本展示自定义tooltip
Vue.directive('ioc-tooltip', {
  bind (el) {
    const tips = el.getAttribute('data-title')
    if (tips && tips.length) {
      let tooltipShow = false
      // let tooltipEl = document.createElement('p');
      // 鼠标悬停时展示自定义tooltip
      el.onmouseover = function () {
        if (tooltipShow) {
          return
        }
        const elPosition = utils.getOffsetByBody(el)
        tooltipShow = true
        console.log('----------onmouseover---------', tips, elPosition)
      }

      // 鼠标离开时隐藏自定义tooltip
      el.onmouseout = function () {
        if (!tooltipShow) {
          return
        }
        tooltipShow = false
        console.log('---------onmouseout----------', tips)
      }
    }
  },
})
//操作权限-指令
Vue.directive('auth', {
  // 当绑定元素插入到 DOM 中
  bind: function (el, binding) {
    const btnName = binding.value || binding.expression
    const item = binding.arg
    const isAuth = getBtnsPermission(el, btnName)
    if (!isAuth) {
      try {
        el.parentNode.removeChild(el)
      } catch (error) {
        return
      }
    }
  },
  inserted: function (el, binding) {
    const btnName = binding.value || binding.expression
    const isAuth = getBtnsPermission(el, btnName)
    if (!isAuth) {
      try {
        el.parentNode.removeChild(el)
      } catch (error) {
        return
      }
    }
  },
  //当绑定元素的指令值更新时,重新赋值
  update: function (el, binding) {
    const btnName = binding.value || binding.expression
    const isAuth = getBtnsPermission(el, btnName)
    if (!isAuth) {
      try {
        el.parentNode.removeChild(el)
      } catch (error) {
        return
      }
    }
  },
})
// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
  bind (el) {
    // 弹框可拉伸最小宽高
    // console.log(el)
    const minWidth = 400
    const minHeight = 300
    // 初始非全屏
    let isFullScreen = false
    // 当前宽高
    let nowWidth = 0
    // eslint-disable-next-line no-unused-vars
    let nowHight = 0
    // 当前顶部高度
    let nowMarginTop = 0
    // 获取弹框头部（这部分可双击全屏）
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    // console.log(dialogHeaderEl)
    // 弹窗
    const dragDom = el.querySelector('.el-dialog')
    // 给弹窗加上overflow auto；不然缩小时框内的标签可能超出dialog；
    // console.log(dragDom)
    dragDom.style.overflow = 'auto'
    // 清除选择头部文字效果
    // dialogHeaderEl.onselectstart = new Function("return false");
    // 头部加上可拖动cursor
    dialogHeaderEl.style.cursor = 'move'
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)
    const moveDown = (e) => {
      // console.log(e)
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop
      // 获取到的值带px 正则匹配替换
      let styL, styT
      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/\px/g, '')
        styT = +sty.top.replace(/\px/g, '')
      }
      document.onmousemove = function (e) {
        // console.log(e)
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        const t = e.clientY - disY
        // 移动当前元素
        dragDom.style.left = `${l + styL}px`
        dragDom.style.top = `${t + styT}px`
        // 将此时的位置传出去
        // binding.value({x:e.pageX,y:e.pageY})
      }
      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
    dialogHeaderEl.onmousedown = moveDown
    // 双击头部全屏效果
    dialogHeaderEl.ondblclick = () => {
      if (isFullScreen === false) {
        nowHight = dragDom.clientHeight
        nowWidth = dragDom.clientWidth
        nowMarginTop = dragDom.style.marginTop
        dragDom.style.left = 0
        dragDom.style.top = 0
        dragDom.style.height = '100VH'
        dragDom.style.width = '100VW'
        dragDom.style.marginTop = 0
        isFullScreen = true
        dialogHeaderEl.style.cursor = 'initial'
        dialogHeaderEl.onmousedown = null
      } else {
        dragDom.style.height = 'auto'
        dragDom.style.width = nowWidth + 'px'
        dragDom.style.marginTop = nowMarginTop
        isFullScreen = false
        dialogHeaderEl.style.cursor = 'move'
        dialogHeaderEl.onmousedown = moveDown
      }
    }
    dragDom.onmousemove = function (e) {
      if (e.clientX > dragDom.offsetLeft + dragDom.clientWidth - 10 || dragDom.offsetLeft + 10 > e.clientX) {
        dragDom.style.cursor = 'w-resize'
      } else if (el.scrollTop + e.clientY > dragDom.offsetTop + dragDom.clientHeight - 10) {
        dragDom.style.cursor = 's-resize'
      } else {
        dragDom.style.cursor = ''
        dragDom.onmousedown = null
      }
      dragDom.onmousedown = (e) => {
        const clientX = e.clientX
        const clientY = e.clientY
        const elW = dragDom.clientWidth
        const elH = dragDom.clientHeight
        const EloffsetLeft = dragDom.offsetLeft
        const EloffsetTop = dragDom.offsetTop
        // dragDom.style.userSelect = 'none'
        const ELscrollTop = el.scrollTop
        // 判断点击的位置是不是为头部
        if (clientX > EloffsetLeft && clientX < EloffsetLeft + elW && clientY > EloffsetTop && clientY < EloffsetTop + 100) {
          // 如果是头部在此就不做任何动作，以上有绑定dialogHeaderEl.onmousedown = moveDown;
        } else {
          document.onmousemove = function (e) {
            // e.preventDefault() // 移动时禁用默认事件
            // 左侧鼠标拖拽位置
            if (clientX > EloffsetLeft && clientX < EloffsetLeft + 10) {
              // 往左拖拽
              if (clientX > e.clientX) {
                dragDom.style.width = elW + (clientX - e.clientX) * 2 + 'px'
              }
              // 往右拖拽
              if (clientX < e.clientX) {
                if (dragDom.clientWidth > minWidth) {
                  dragDom.style.width = elW - (e.clientX - clientX) * 2 + 'px'
                }
              }
            }
            // 右侧鼠标拖拽位置
            if (clientX > EloffsetLeft + elW - 10 && clientX < EloffsetLeft + elW) {
              // 往左拖拽
              if (clientX > e.clientX) {
                if (dragDom.clientWidth > minWidth) {
                  dragDom.style.width = elW - (clientX - e.clientX) * 2 + 'px'
                }
              }
              // 往右拖拽
              if (clientX < e.clientX) {
                dragDom.style.width = elW + (e.clientX - clientX) * 2 + 'px'
              }
            }
            // 底部鼠标拖拽位置
            if (ELscrollTop + clientY > EloffsetTop + elH - 20 && ELscrollTop + clientY < EloffsetTop + elH) {
              // 往上拖拽
              if (clientY > e.clientY) {
                if (dragDom.clientHeight > minHeight) {
                  dragDom.style.height = elH - (clientY - e.clientY) * 2 + 'px'
                }
              }
              // 往下拖拽
              if (clientY < e.clientY) {
                dragDom.style.height = elH + (e.clientY - clientY) * 2 + 'px'
              }
            }
          }
          // 拉伸结束
          document.onmouseup = function () {
            document.onmousemove = null
            document.onmouseup = null
          }
        }
      }
    }
  }
})
// v-dgWidth: 设置宽度
Vue.directive('ops', {
  bind (el, binding, vnode, oldVnode) {
    const s = binding.arg
    const dragDom = el.querySelector('.el-dialog')
    dragDom.style[s] = binding.value + 'px'
  },
})

// v-dialogDragWidth: 弹窗宽度拖大 拖小
Vue.directive('dialogDragWidth', {
  bind (el, binding, vnode, oldVnode) {
    const dragDom = binding.value.$el.querySelector('.el-dialog')

    el.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - el.offsetLeft

      document.onmousemove = function (e) {
        e.preventDefault() // 移动时禁用默认事件

        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        dragDom.style.width = `${l}px`
      }

      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  },
})
/*
 *@name: 元素状态控制自定义指令
 *@param:{type}
 *@description:
 *@return:
 *@author: panlua
 *@date: 2019-05-25 15:49:23
 */
Vue.directive('status', {
  bind (el, binding, vnode) {
    el.onclick = (e) => {
      let time = binding.value || 3000
      $(el).attr('disabled', 'disabled')
      $(el).addClass('is-disabled')
      setTimeout(() => {
        $(el).removeAttr('disabled')
        $(el).removeClass('is-disabled')
      }, time)
    }
  },
})
/*
 *@name: 对元素中展示的文本进行脱敏处理，将元素中的文本根据长度设置成*号展示
 *@param:{type}
 *@description:
 *@return:
 *@author: slfang
 *@date: 2020-12-04 10:59:35
 */
Vue.directive('encrypt', {
  // 当绑定元素插入到 DOM 中
  bind: function (el, binding) {
    $(el).text(utils.encryptStr($(el).text()));
  },
  inserted: function (el, binding) {
    $(el).text(utils.encryptStr($(el).text()));
  },
  //当绑定元素的指令值更新时,重新赋值
  update: function (el, binding) {
    $(el).text(utils.encryptStr($(el).text()));
  },
})

/*
 *@name: v-scale 只对element  el-dialog 元素生效  拖拽右下角，控制el-dialog放大缩小 需要配合el-dialog属性:close-on-click-modal="false" 一起使用
 *@param:{type} minWidth: 最小宽度 默认300  minHeight: 最小高度 默认150
 *@description:
 *@return:
 *@author: panlua
 *@date: 2019-06-14 09:55:16
 */
Vue.directive('scale', {
  bind (el, binding, vnode) {
    const minWidth = binding.value ? binding.value.minWidth : 300
    const minHeight = binding.value ? binding.value.minHeight : 150
    // 在el-dialog元素末尾追加拖拽元素
    let parentDiv = $(el).find('.el-dialog')[0]
    $(parentDiv).append(
      '<span class="drag" title="拖拽缩放" style="position: absolute;bottom: 0;right: 0;width: 5px;height: 5px;cursor: se-resize;"></span>'
    )
    setTimeout(() => {
      let oDiv = $('.el-dialog .drag')[0]
      let state = false
      $(oDiv).mousedown(function (ev) {
        let elDialogBody = $(el).find('.el-dialog__body')[0]
        let elDialogHeader = $(el).find('.el-dialog__header')[0]
        state = true
        ev = ev || event
        let disX = ev.clientX - oDiv.offsetLeft
        let disY = ev.clientY - oDiv.offsetTop
        $(document).mousemove(function (ev) {
          if (state) {
            ev = ev || event
            let width = ev.clientX - disX + oDiv.offsetWidth
            let height = ev.clientY - disY + oDiv.offsetHeight
            if (width > minWidth) {
              $(elDialogBody).css('width', width + 'px')
              $(parentDiv).css('width', width + 'px')
            }
            if (height > minHeight) {
              $(elDialogBody).css('height', height + 'px')
              $(parentDiv).css('height', height + $(elDialogHeader)[0].offsetHeight + 'px')
            }
          }
        })
      })
      $(document).mouseup(function () {
        state = false
      })
      $(oDiv).mouseup(function () {
        state = false
      })
    })
  },
})

/*
 *@name: v-elDrag  支持任意元素拖动位置
 *@param:{type} moveEl  拖动元素
 *@description:
 *@return:
 *@author: panlua
 *@date: 2019-06-18 10:45:19
 */
Vue.directive('elDrag', {
  bind (el, bind, vnode) {
    $(el).css('cursor', 'move')
    const controlEl = el
    setTimeout(() => {
      const moveEl = $(bind.value.moveEl)[0]
      // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
      const sty = moveEl.currentStyle || window.getComputedStyle(moveEl, null)
      $(controlEl).mousedown((e) => {
        const disX = e.clientX - controlEl.offsetLeft
        const disY = e.clientY - controlEl.offsetTop

        // 获取到的值带px 正则匹配替换
        let styL, styT
        // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
        if (sty.left.includes('%')) {
          styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100) // eslint-disable-line
          styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100) // eslint-disable-line
        } else {
          styL = +sty.left.replace(/\px/g, '')
          styT = +sty.top.replace(/\px/g, '')
        }

        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          const l = e.clientX - disX
          const t = e.clientY - disY
          // 移动当前元素
          moveEl.style.left = `${l + styL}px`
          if (t + styT <= 60) {
            return false
          }
          moveEl.style.top = `${t + styT}px`

          //将此时的位置传出去
          //binding.value({x:e.pageX,y:e.pageY})
        }

        document.onmouseup = function (e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      })
    })
  },
})